<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/finance' }">财务管理</el-breadcrumb-item>
            <el-breadcrumb-item>充值</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="form-box">
            <div class="charge-box" style="width: 682px;margin: 0 auto;">
                <div class="sub-page__title text-center">线下充值汇款</div>
                <div class="tip-box">
                    <div class="tip-box__label">
                        <p>温馨提示</p>
                    </div>
                    <div class="tip-box__content">
                        <p>1. 汇款时，请准确填写金穗智管开户行信息及获取到的专属账号。</p>
                        <p>2. 线下汇款直接向金穗智管专属账号汇款，系统会将汇款直接匹配到您的金穗智管账户。</p>
                        <p>3. 各银行汇款到账时间一般为3个工作日，具体到账时间以银行的实际到账时间为准。</p>
                    </div>
                </div>
                <div class="sub-page__main" style="width: 375px; margin: 0 auto;">
                    <el-form label-width="100px" label-position="left">
                        <el-form-item label="公司名称">
                            {{account.company_name}}
                        </el-form-item>
                        <el-form-item v-if="account.virtual_account === ''" label="汇款账号">
                            <el-button type="primary" @click="createAccount">获取商户专属账号</el-button>
                        </el-form-item>
                        <div v-else>
                            <el-form-item label="收款账号">
                                {{account.virtual_account}}
                            </el-form-item>
                            <el-form-item label="开户名称">
                                {{account.account_name}}
                            </el-form-item>
                            <el-form-item label="开户银行">
                                {{account.bank_name}}
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Charge',
    inject: ['goPage'],
    data () {
        return {
            account: {
            }
        }
    },
    mounted () {
        this.getAccount()
    },
    methods: {
        getAccount () {
            this.$http.get('/api/user/getvirtualaccount')
                .then((res) => {
                    if (res.code === 0) {
                        this.account = res.data
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                    // this.$Message.error('网络错误，请稍候再试。');
                })
        },
        createAccount () {
            this.$http.get('/api/user/createvirtualaccount')
                .then((res) => {
                    if (res.code === 0) {
                        this.account = res.data
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                    // this.$Message.error('网络错误，请稍候再试。');
                })
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var";
    @import "../../assets/style/sub.scss";

    .charge-box {
        .el-form-item {
            margin-bottom: 10px;
        }

        .sub-page__title {
            font-size: 20px;
            font-weight: bold;
            color: #29322D;
            padding: 10px 0 40px;
        }

        .tip-box {
            display: flex;
            border: 1px solid $--border-color-base;
            background-color: #f3f4f7;
            padding: 25px 20px;
            font-size: 14px;
            margin-bottom: 32px;

            p {
                line-height: 2;
                margin-bottom: 0;
            }

            .tip-box__label {
                color: $--color-danger;
                margin-right: 30px;
            }

            .tip-box__content {
                color: #666;
            }
        }

        .sub-page__main {

        }
    }
</style>
